import React from 'react';
import { Link } from 'react-router-dom';

export default function SaaSPage() {
  return (
    <main className="main" style={{ textAlign: 'center', paddingTop: '4rem' }}>
      <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔐</div>
      <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.5rem' }}>
        SSL for SaaS
      </h1>
      <p style={{ color: 'var(--cf-muted)', fontSize: '1rem', marginBottom: '2rem' }}>
        Coming Soon
      </p>
      <p style={{ color: 'var(--cf-muted)', fontSize: '0.875rem', maxWidth: '400px', margin: '0 auto 2rem' }}>
        Custom hostname provisioning, automatic certificate issuance, and fallback origin configuration for SaaS providers.
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          padding: '0.6rem 1.25rem',
          background: 'var(--cf-orange)',
          color: 'white',
          borderRadius: '8px',
          fontWeight: 600,
          fontSize: '0.875rem',
        }}
      >
        ← Back to Home
      </Link>
    </main>
  );
}
